import { OrderRequest, RequestStatus, RequestType } from 'app/pages/order/redux/model/order-request';

class OrderRequestsUtils {
    public static readonly NOT_RETRYABLE_FAILED_REQUESTS = [RequestType.GET_PARTNERS];

    public static withStartedRequest(
        requests: OrderRequest[],
        requestId: string,
        requestType: RequestType,
    ): OrderRequest[] {
        return [
            ...requests.filter((request) => request.requestType !== requestType),
            { requestId, requestType, status: RequestStatus.PENDING },
        ];
    }

    public static withCompletedRequest(requests: OrderRequest[], requestId: string): OrderRequest[] {
        return requests.map((request) =>
            request.requestId === requestId ? { ...request, status: RequestStatus.COMPLETED } : request,
        );
    }

    public static withFailedOrderRequest(requests: OrderRequest[], requestId: string): OrderRequest[] {
        return requests.map((request) =>
            request.requestId === requestId ? { ...request, status: RequestStatus.FAILED } : request,
        );
    }

    public static isRequestInitialized(requests: OrderRequest[], requestId: string): boolean {
        return !!requests.find((request) => request.requestId === requestId);
    }

    public static isRequestPending(requests: OrderRequest[], ...requestTypes: RequestType[]): boolean {
        return requestTypes.some((requestType) =>
            requests.some((request) => request.requestType === requestType && request.status === RequestStatus.PENDING),
        );
    }

    public static isRequestsCompleted(requests: OrderRequest[], ...requestType: RequestType[]): boolean {
        return requestType.every((_requestType) =>
            requests.some(
                (request) =>
                    request.requestType === _requestType &&
                    [RequestStatus.COMPLETED, RequestStatus.FAILED].includes(request.status),
            ),
        );
    }

    public static shouldCreateRequest(requests: OrderRequest[], requestType: RequestType): boolean {
        return !requests.some(
            (request) =>
                request.requestType === requestType &&
                ([RequestStatus.COMPLETED, RequestStatus.PENDING].includes(request.status) ||
                    this.isNotRetryableFailedRequest(request)),
        );
    }

    private static isNotRetryableFailedRequest(request: OrderRequest): boolean {
        return (
            this.NOT_RETRYABLE_FAILED_REQUESTS.includes(request.requestType) && request.status === RequestStatus.FAILED
        );
    }
}

export { OrderRequestsUtils };
